import React from 'react'
import { AdCreative, AdCreativeType } from '@marketing-milk/interfaces'

type Props = {
  creative: AdCreative
  property: keyof AdCreative
}
export const CreativePill = ({ creative, property }: Props) => {
  const getReviewStatusStyles = ({ reviewStatus }: AdCreative) => {
    if (reviewStatus === 'ready') return 'text-green-800 bg-green-100'
    if (reviewStatus === 'pending') return 'text-green-800 bg-green-100'
    if (reviewStatus === 'rejected') return 'text-red-800 bg-red-100'
    if (reviewStatus === 'draft') return 'text-blue-800 bg-blue-100'
    return 'text-purple-900 bg-purple-100'
  }

  const getTypeStyles = ({ format }: AdCreative) => {
    if (format === AdCreativeType.single_image) return 'text-green-800 bg-green-100'
    if (format === AdCreativeType.single_video) return 'text-blue-800 bg-blue-100'
    if (format === AdCreativeType.carousel) return 'text-yellow-800 bg-yellow-100'
    if (format === AdCreativeType.dynamic) return 'text-red-800 bg-red-100'
    return 'text-purple-900 bg-purple-100'
  }

  const getPillStyles = () => {
    if (property === 'format') return getTypeStyles(creative)
    if (property === 'reviewStatus') return getReviewStatusStyles(creative)
    return ''
  }

  return (
    <span
      className={
        'px-3 py-0.5 text-xs font-semibold rounded-full w-auto flex shadow-sm' +
        ' ' +
        getPillStyles()
      }
    >
      {creative[property]?.toString().replace('_', ' ')}
    </span>
  )
}
